import { Col, Input, Row, Select, Table } from "antd";
import { Field, Form, Formik } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import PaginationComponent from "../../../shared/components/PaginationComponent";
import { SearchOutlined } from "@ant-design/icons";

import { deserialize } from "serializr";
import CommonService from "../../../services/CommonService/common.service";
import BranchService from "../../../services/InstituteService/branch.service";
import BoardService from "../../../services/CourseServices/BoardService/board.service";
import SectionService from "../../../services/InstituteService/section.service";
import LeaderboardService from "../../../services/LeaderboardService/leaderboard.service";

import { MetaModel } from "../../../models/CourseModels/SubjectModel/subject.model";
import { FilterLeaderboard, Leaderboard, } from "../../../models/LeaderboardModel/Leaderboard.model";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import { BranchClassRoomsModel } from "../../../models/InstituteModel/branches.model";


interface ClassroomLeaderboardProps {
  institutes: MetaModel[];
  user: any
}

const ClassroomLeaderboard: FC<ClassroomLeaderboardProps> = (props) => {
  const { institutes, user } = props;

  const [initialValues, setInitialValues] = useState<FilterLeaderboard>({
    type: "institute",
  });
  const [branches, setBranches] = useState<MetaModel[]>([]);
  const [boards, setBoards] = useState<MetaModel[]>([]);
  const [branchClassRooms, setBranchClassRooms] = useState<MetaModel[]>([]);
  const [sections, setSections] = useState<MetaModel[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [sectionSubjects, setSectionSubjects] = useState<MetaModel[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<PaginationModel>({});
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [leaderboardData, setLeaderboardData] = useState<Leaderboard[]>([]);
  const [query, setQuery] = useState<FilterLeaderboard>({});
  const formRef = useRef<any>();


  useEffect(() => {
    if (institutes.length && user?.roleName === "instituteadmin") {
      let currentInstituteID = Number(institutes[0].value)
      setInitialValues({ ...initialValues, instituteId: currentInstituteID })
      fetchBranches(currentInstituteID)
    }
  }, [institutes])

  const handleSubmit = (values: FilterLeaderboard) => {
    setQuery(values);
    setCurrentPageNumber(1)
    if (values.type === 'institute' && values.boardId && values.branchId) {
      fetchLearderboardByInst(values)
    } else if (values.type === 'onboard' && values.boardId) {
      fetchLearderboardByOnboard(values)
    }
  };

  const fetchLearderboardByInst = (values: FilterLeaderboard) => {
    setLoading(true)
    LeaderboardService.fetchLearderboardByInst(
      values,
      (data, meta) => {
        setLeaderboardData(data);
        setPaginationMeta(meta);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchLearderboardByOnboard = (values: FilterLeaderboard) => {
    setLoading(true)
    LeaderboardService.fetchLearderboardByOnboard(
      values,
      (data, meta) => {
        setLeaderboardData(data);
        setPaginationMeta(meta);
      },
      () => { },
      () => { setLoading(false) }
    );
  }

  const fetchBranches = (id: number) => {
    CommonService.fetchBranchesMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBranches(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBoards = () => {
    CommonService.fetchBoardsMeta(
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setBoards(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSections = (branchId: number, classId: number) => {
    CommonService.fetchSectionsMeta(
      { ClassId: classId, BranchId: branchId },
      (data) => {
        const response = deserialize(MetaModel, data) as MetaModel[];
        setSections(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchSectionSubjects = (id: number) => {
    CommonService.fetchSubjectsMeta(
      id,
      (data) => {
        const response = deserialize(MetaModel, data);
        setSectionSubjects(response);
      },
      () => { },
      () => { }
    );
  };

  const fetchBranchClassRooms = (branchId: number) => {
    CommonService.fetchGradeMeta(
      branchId,
      (data) => {
        const meta = deserialize(MetaModel, data) as MetaModel[];
        setBranchClassRooms(meta);
      },
      () => { },
      () => { }
    );
  };

  const handlePageChange = (page: number, pageSize?: number) => {
    handleSubmit({ ...query, page, pageSize });
    setCurrentPageNumber(page);
  };

  useEffect(() => {
    fetchBoards();
  }, []);

  const clearForm = () => {
    user?.roleName === "admin" && setBranches([])
    setSections([])
    setSectionSubjects([])
    setBranchClassRooms([])
    setLeaderboardData([]);
    setQuery({});
    setLoading(false);
  }




  return (
    <div className="classroom-leaderboard">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm, dirty }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="institute-leaderboard-filters__container">
                <Row
                  className="classroom-leaderboard-filters__wrapper"
                  gutter={24}
                >
                  <Col span={18}>
                    <Row gutter={[24, 24]}>
                      <Col span={8}>
                        <div className="institute-leaderboard-filter-field__container">
                          <div className="institute-leaderboard-filter-field__label">
                            Filter by
                          </div>
                          <Field
                            disabled={user?.roleName === "instituteadmin" ? true : false}
                            as={Select}
                            name="type"
                            options={[
                              {
                                value: "institute",
                                label: "Institute",
                              },
                              {
                                value: "onboard",
                                label: "Self onboarded",
                              },
                            ]}
                            value={values?.type}
                            placeholder="Select Filter"
                            onChange={(value) => {
                              resetForm()
                              setFieldValue("type", value)
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <>
                          <Col span={8}>
                            <div className="institute-leaderboard-filter-field__container">
                              <div className="institute-leaderboard-filter-field__label">
                                Institute
                              </div>
                              <Field
                                disabled={user?.roleName === "instituteadmin" ? true : false}
                                as={Select}
                                name="instituteId"
                                value={values?.instituteId}
                                options={institutes}
                                placeholder="Select Institute"
                                onChange={(value) => {
                                  resetForm()
                                  setFieldValue("instituteId", value);
                                  value && fetchBranches(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                          <Col span={8}>
                            <div className="institute-leaderboard-filter-field__container">
                              <div className="institute-leaderboard-filter-field__label">
                                Branch
                              </div>
                              <Field
                                as={Select}
                                options={branches}
                                name="branchId"
                                value={values?.branchId}
                                placeholder="Select Branch"
                                onChange={(value) => {
                                  setFieldValue("branchId", value);
                                  setFieldValue("branchClassRoomId", null);
                                  setFieldValue("sectionId", null);
                                  setFieldValue("sectionSubjectId", null);
                                  fetchBranchClassRooms(value);
                                }}
                              ></Field>
                            </div>
                          </Col>
                        </>
                      )}

                      <Col span={8}>
                        <div className="institute-leaderboard-filter-field__container">
                          <div className="institute-leaderboard-filter-field__label">
                            Board
                          </div>
                          <Field
                            as={Select}
                            name="boardId"
                            options={boards}
                            value={values?.boardId}
                            placeholder="Select Board"
                            onChange={(value) =>
                              setFieldValue("boardId", value)
                            }
                          ></Field>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="institute-leaderboard-filter-field__container">
                          <div className="institute-leaderboard-filter-field__label">
                            Class
                          </div>
                          <Field
                            as={Select}
                            name="branchClassRoomId"
                            options={branchClassRooms}
                            value={values?.branchClassRoomId}
                            placeholder="Select Class"
                            onChange={(value) => {
                              setFieldValue("branchClassRoomId", value);
                              setFieldValue("sectionId", null);
                              setFieldValue("sectionSubjectId", null);
                              fetchSectionSubjects(value);
                              values?.branchId &&
                                fetchSections(values?.branchId, value);
                            }}
                          ></Field>
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <Col span={8}>
                          <div className="institute-leaderboard-filter-field__container">
                            <div className="institute-leaderboard-filter-field__label">
                              Section
                            </div>
                            <Field
                              as={Select}
                              name="sectionId"
                              options={sections}
                              value={values?.sectionId}
                              placeholder="Select Section"
                              onChange={(value) => {
                                setFieldValue("sectionId", value);
                              }}
                            ></Field>
                          </div>
                        </Col>
                      )}
                      {values?.type == "onboard" && (
                        <Col span={8}>
                          <div className="institute-leaderboard-filter-field__container">
                            <div className="institute-leaderboard-filter-field__label">
                              Subject
                            </div>
                            <Field
                              as={Select}
                              options={sectionSubjects}
                              name="sectionSubjectId"
                              value={values?.sectionSubjectId}
                              placeholder="Select Subject"
                              onChange={(value) =>
                                setFieldValue("sectionSubjectId", value)
                              }
                            ></Field>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col span={6}>
                    <Row gutter={[24, 20]}>
                      <Col span={24}>
                        <div className="institute-leaderboard-filter-btn__wrapper">
                          <ButtonComponent
                            type="text"
                            buttonContent={"Clear Filters"}
                            onClick={() => {
                              resetForm();
                              clearForm()
                            }}
                          />
                          <ButtonComponent
                            type="primary"
                            loading={loading}
                            buttonContent={"Apply Filters"}
                            onClick={() => handleSubmit(values)}
                          />
                        </div>
                      </Col>
                      {values?.type == "institute" && (
                        <Col span={24}>
                          <div className="institute-leaderboard-filter-field__container">
                            <div className="institute-leaderboard-filter-field__label">
                              Subject
                            </div>
                            <Field
                              as={Select}
                              name="sectionSubjectId"
                              options={sectionSubjects}
                              value={values?.sectionSubjectId}
                              placeholder="Select Subject"
                              onChange={(value) =>
                                setFieldValue("sectionSubjectId", value)
                              }
                            ></Field>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>
              <div className="institute-leaderboard-search__container">
                {/* <Input
                  placeholder="Search by any branch, class, section ..."
                  prefix={<SearchOutlined />}
                  disabled={query ? false : true}
                  onChange={(e) => {
                    handleSubmit({ ...query, search: e.target.value });
                  }}
                /> */}
                {leaderboardData?.length ? (
                  <p>
                    Showing results {leaderboardData?.length == paginationMeta?.totalCount ? paginationMeta?.totalCount : ((currentPageNumber - 1) * (leaderboardData?.length<(paginationMeta?.pageSize?paginationMeta?.pageSize:0)?(paginationMeta?.pageSize?paginationMeta?.pageSize:0):leaderboardData?.length) + 1) + " - " + (((currentPageNumber - 1) * (paginationMeta?.pageSize?paginationMeta?.pageSize:0)) + leaderboardData?.length)}/
                    <span>{paginationMeta?.totalCount}</span>
                  </p>
                ) : (
                  ""
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
      <Table
        columns={[
          {
            title: "Rank",
            key: "rank",
            dataIndex: "rank",
            render: (rank: number) => {
              return rank == 1 ? (
                <div className="first__rank">{rank}</div>
              ) : rank == 2 ? (
                <div className="second__rank">{rank}</div>
              ) : rank == 3 ? (
                <div className="third__rank">{rank}</div>
              ) : (
                <div className="rank">{rank}</div>
              );
            },
            sorter: (a: any, b: any) => a?.rank - b?.rank,
          },
          {
            title: "Points",
            dataIndex: "cummulativeScore",
            key: "cummulativeScore",
          },
          {
            title: "ID",
            dataIndex: "studentId",
            key: "studentId",
          },
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
          },
          {
            title: "Class",
            dataIndex: "classRoom",
            key: "classRoom",
          },
          {
            title: "Phone number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
          },
          {
            title: "Email ID",
            dataIndex: "email",
            key: "email",
          },
        ]}
        dataSource={leaderboardData}
        pagination={false}
        loading={loading}
      />
      <PaginationComponent
        handlePageChange={handlePageChange}
        paginationMeta={paginationMeta}
      />
    </div>
  );
};

export default ClassroomLeaderboard;
